import script from "./MaintenanceNoticeHost.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceNoticeHost.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceNoticeHost.vue?vue&type=style&index=0&id=7ee6fe6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee6fe6e"]])

export default __exports__